export default __webpack_public_path__ + "static/Sue.Thilo_social-f6c0610e07d90b03bda753339a087031.jpg";